export const SAVE_IMY_TREEVIEW_OPTIONS = 'SAVE_IMY_TREEVIEW_OPTIONS';
export const SET_PAYMENT_TYPES = 'SET_PAYMENT_TYPES';
export const UPDATE_AVAILABLE_PAYMENT_TYPES = 'UPDATE_AVAILABLE_PAYMENT_TYPES';
export const SET_STRUCTURE_ID = 'SET_STRUCTURE_ID';

function processSave(id, options) {
  return {
    type: SAVE_IMY_TREEVIEW_OPTIONS,
    options,
    id
  };
}

export function saveImyTreeViewOptions(id, options) {
  return (dispatch) => {
    if (options) {
      dispatch(processSave(id, options));
    }
  };
}

export function setPaymentTypes(structureId, options) {
  return {
    type: SET_PAYMENT_TYPES,
    structureId,
    options
  };
}

export function setStructureId(id) {
  return {
    type: SET_STRUCTURE_ID,
    id
  };
}

export function updateAvailablePaymentTypes(structureId, paymentTypes) {
  return {
    type: UPDATE_AVAILABLE_PAYMENT_TYPES,
    structureId,
    paymentTypes
  };
}
